import DeleteUser from './DeleteUser';

export default DeleteUser;